import { render, staticRenderFns } from "./AzTextViewEditSelectTipoDocumento.vue?vue&type=template&id=89b962c2&scoped=true&"
import script from "./AzTextViewEditSelectTipoDocumento.vue?vue&type=script&lang=js&"
export * from "./AzTextViewEditSelectTipoDocumento.vue?vue&type=script&lang=js&"
import style0 from "./AzTextViewEditSelectTipoDocumento.vue?vue&type=style&index=0&id=89b962c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b962c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VTooltip})
